import { API_URL } from '../api/config';

/**
 * Get the full avatar URL from avatar path
 * Handles both local paths and external URLs (Google, Facebook, etc.)
 *
 * @param {string} avatarPath - Avatar path or URL
 * @returns {string} Full avatar URL or empty string
 */
export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return '';
  if (avatarPath.startsWith('http')) return avatarPath;
  return `${API_URL}${avatarPath}`;
};

/**
 * Get default avatar URL
 *
 * @returns {string} Default avatar URL
 */
export const getDefaultAvatarUrl = () => {
  return `${API_URL}/uploads/avatars/default.svg`;
};
